import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { AppLoaderProvider } from './components/shared/app-loader-provider';
import './index.css';
import { initInputModality } from './lib/input-modality';
import { handleCaughtError } from './lib/react-root-errors';
import { handleUnhandledRejection, handleVitePreloadError } from './lib/stale-chunk-reload';
import { reportStaleChunkReload } from './lib/stale-chunk-report';
import { initSentry } from './lib/sentry';
import { initDatadogRum } from './lib/datadog-rum';

// Auto-reload once when a stale chunk hash from a prior deploy 404s a dynamic import.
// Suppress browser-extension noise (password managers, ad blockers) that leaks into the console.
globalThis.addEventListener('vite:preloadError', handleVitePreloadError);
globalThis.addEventListener('unhandledrejection', handleUnhandledRejection);

// Initialize Sentry for error tracking
initSentry();

// Initialize Datadog RUM for real-user monitoring (no-op without env vars)
initDatadogRum();

// Report a stale-chunk recovery from the PREVIOUS boot. Must follow both inits.
reportStaleChunkReload();

// Stamp pointer-vs-keyboard modality on <html> so focus rings stay keyboard-only.
initInputModality();

// Suppress the self-healing PDF.js worker-teardown race from console/Sentry —
// see src/lib/react-root-errors.ts.
createRoot(document.querySelector('#root'), { onCaughtError: handleCaughtError }).render(
  <AppLoaderProvider>
    <App />
  </AppLoaderProvider>,
);

// Dev-only: network request bubble overlay
if (import.meta.env.DEV) {
  const { bootstrap } = await import('@/components/debug/network-bubbles');
  bootstrap();
}
